module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Protected-file-5b9987bec2528b28cf654f7a25846687.svg";